import React, { useState } from 'react';
import { experiences } from '../../data/experiences';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import '../../styles/components/Experience.css';
import '../../styles/animations.css';

const Experience = () => {
  const [expandedJob, setExpandedJob] = useState(null);
  const { elementRef, isVisible } = useScrollAnimation();

  const toggleJobDescription = (jobId) => {
    setExpandedJob(expandedJob === jobId ? null : jobId);
  };

  return (
    <div className="section">
      <div
        ref={elementRef}
        className={`experience-section animate-section ${isVisible ? 'visible' : ''}`}
      >
        <h2 className={`animate-element delay-1 ${isVisible ? 'visible' : ''}`}>
          Professional Experience
        </h2>
        <div className="experience-list">
          {experiences.map((experience, index) => (
            <div
              key={experience.id}
              className={`experience-item animate-element delay-${Math.min(index + 2, 6)} ${isVisible ? 'visible' : ''}`}
            >
              <div
                className="experience-header clickable"
                onClick={() => toggleJobDescription(experience.id)}
              >
                <div className="experience-header-content">
                  <h3 className="job-title">{experience.title}</h3>
                  <div className="job-company">
                    <a
                      href={experience.companyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {experience.company}
                    </a>
                  </div>
                  <div className="job-period">{experience.period}</div>
                </div>
                <div className="toggle-icon">
                  {expandedJob === experience.id ? '−' : '+'}
                </div>
              </div>
              {expandedJob === experience.id && (
                <div
                  className="job-description expanded"
                  dangerouslySetInnerHTML={{ __html: experience.description }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience; 